const stMob = {
  containList: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    padding: '10px',
  },
  labelPage: {
    fontSize: '13px',
    color: 'gray',
    marginBottom: '10px',
  },
}

export { stMob }
